import axios from 'axios'
import { buildQuery } from '../exports/queryStringBuilder'
export default {
    async create(model) {
        return await axios.post(`targets`, model)
    },
    async duplicate(model){
        return await axios.post(`targets/duplicate`, model)
    },
    async bulkDelete(model){
        return await axios.post(`targets/bulkDelete`, model)
    },
    async fetchById(id) {
        return await axios.get(`targets/${id}`)
    },
    async fetch(query, page,filters) {
      
        return await axios.get(`targets?q=${query}&page=${page}&` + buildQuery(filters));
    },
    async fetchNames(){
        return await axios.get(`targets/get-names`);
    },
    async getTargetProgress(filter){
        return await axios.get(`targets/get-target-progress?` + buildQuery(filter));
    },
    async getValueProgress(filter){
        return await axios.get(`targets/get-value-progress?` + buildQuery(filter));
    },
    async getTargetProgressOfficer(filter){
        return await axios.get(`targets/get-target-progress-officer?` + buildQuery(filter));
    },
    async getValueProgressOfficer(filter){
        return await axios.get(`targets/get-value-progress-officer?` + buildQuery(filter));
    },
    async fetchActivity(filter){
        return await axios.get(`targets/fetch-activity?` + buildQuery(filter));
    },
    async getYearRecord(filter){
        return await axios.get(`targets/get-year-data?` + buildQuery(filter));
    },
    async getModelDataForMonth(filter){
        return await axios.get(`targets/get-month-record?` + buildQuery(filter));
    },
    async getModelDataByMonth(filter){
        return await axios.get(`targets/get-months-record?` + buildQuery(filter));
    },
    async getModelDataForMonthOfficer(filter){
        return await axios.get(`targets/get-month-record-officer?` + buildQuery(filter));

    },
    async getModelDataByMonthOfficer(filter){
        return await axios.get(`targets/get-months-record-officer?` + buildQuery(filter));
    },
    async getYearRecordOfficer(filter){
        return await axios.get(`targets/get-year-data-officer?` + buildQuery(filter));
    },
    async fetchDrivers() {
        return await axios.get(`user`)
    },
  
    async update(id, model) {
        return await axios.put(`targets/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`targets/${id}`)
    },
}
